import React from 'react';
import { Field } from 'formik';
import { InputProps, Props } from './editor.type';
import TinymceEditor from 'components/base/TinymceEditor';
import { getValueByPath } from 'helpers/utils';

const EditorField = ({ field, form, ...props }: InputProps) => {
  const errorMessage = getValueByPath(form.errors, field.name);

  const isError = Boolean(
    errorMessage && getValueByPath(form.touched, field.name)
  );
  return (
    <>
      <TinymceEditor
        {...field}
        options={{
          height: '10rem'
        }}
        onChange={value => form.setFieldValue(field.name, value)}
      />
      {!props.hideMessage && isError && typeof errorMessage === 'string' && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </>
  );
};

export default function Editor(props: Props) {
  return <Field {...props} component={EditorField} />;
}
